module.exports = __webpack_public_path__ + "assets/img/icon-4.e6687e5b.svg";